import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTreeview } from 'vuetify/lib/components/VTreeview';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "n20-container",
    attrs: {
      "fluid": ""
    }
  }, [_c(VDialog, {
    attrs: {
      "dark": _vm.UiTheme,
      "max-width": "1000px",
      "persistent": ""
    },
    model: {
      value: _vm.twinDuplicatePrompt,
      callback: function ($$v) {
        _vm.twinDuplicatePrompt = $$v;
      },
      expression: "twinDuplicatePrompt"
    }
  }, [_vm.twinDuplicatePrompt ? _c('core-dtwin-duplicate-base', {
    attrs: {
      "orgTwin": _vm.twinObject,
      "orgTwinStates": _vm.twinDataStates
    },
    on: {
      "forceRefreshStates": _vm.forceRefreshStates,
      "close": _vm.duplicateCloseEvent
    }
  }) : _vm._e()], 1), _c(VDialog, {
    attrs: {
      "dark": _vm.UiTheme,
      "max-width": "1000px",
      "persistent": ""
    },
    model: {
      value: _vm.twinSyncPrompt,
      callback: function ($$v) {
        _vm.twinSyncPrompt = $$v;
      },
      expression: "twinSyncPrompt"
    }
  }, [_vm.twinSyncPrompt ? _c('core-dtwin-sync', {
    attrs: {
      "orgTwin": _vm.twinObject,
      "orgTwinStates": _vm.twinDataStates
    },
    on: {
      "close": _vm.syncCloseEvent
    }
  }) : _vm._e()], 1), _c('core-prompt', {
    attrs: {
      "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDeleteConfirmation'),
      "open": _vm.twinDeletePrompt,
      "buttons": [{
        text: _vm.$i18n_t('Common.close'),
        emit: 'cancel'
      }, {
        text: _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDelete'),
        color: 'red',
        emit: 'delete',
        disabled: _vm.twinDependencies === null || !_vm.canDeleteTwin
      }],
      "color": "red"
    },
    on: {
      "cancel": function ($event) {
        _vm.twinDeletePrompt = false;
      },
      "delete": function ($event) {
        return _vm.deleteTwin(_vm.twinObject);
      }
    }
  }, [_vm.twinDependencies && _vm.twinDependencies.aggregatedStates && _vm.twinDependencies.aggregatedStates.length ? [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinDeleteCannotDeleteText')) + "\n      "), _c(VTreeview, {
    staticClass: "mt-2 infoTree",
    attrs: {
      "items": _vm.twinDependencies.aggregatedStates,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function ({
        item
      }) {
        return [item.icon ? _c(VIcon, {
          staticStyle: {
            "width": "25px"
          },
          attrs: {
            "size": "16"
          },
          domProps: {
            "textContent": _vm._s(`fal fa-${item.icon}`)
          }
        }) : _vm._e()];
      }
    }, {
      key: "label",
      fn: function ({
        item
      }) {
        return [item.isTwin ? [_c('a', {
          attrs: {
            "href": `/#/${item.twinType === 'virtualDevice' ? 'virtual-devices' : 'digitaltwin-mgmt'}/${item.id}`,
            "target": "_blank"
          }
        }, [_vm._v("\n              " + _vm._s(item.title) + "\n            ")])] : [_vm._v("\n            " + _vm._s(item.title) + "\n          ")], _vm._v("\n           \n          "), item.id ? _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.id) + ")")]) : _vm._e()];
      }
    }], null, false, 1373246036)
  })] : _vm._e(), _vm.hasDependentTemplates ? [_c('div', {
    class: {
      'mt-4': _vm.twinDependencies && _vm.twinDependencies.aggregatedStates && _vm.twinDependencies.aggregatedStates.length
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinIsParentalObjectTemplates')) + "\n      ")]), _c(VTreeview, {
    staticClass: "mt-2 infoTree",
    attrs: {
      "items": _vm.twinDependencies.deviceTemplates,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "prepend",
      fn: function ({
        item
      }) {
        return [item.icon ? _c(VIcon, {
          staticStyle: {
            "width": "25px"
          },
          attrs: {
            "size": "16"
          },
          domProps: {
            "textContent": _vm._s(`fal fa-${item.icon}`)
          }
        }) : _vm._e()];
      }
    }, {
      key: "label",
      fn: function ({
        item
      }) {
        return [_c('a', {
          attrs: {
            "href": `/#/device-templates/${item.id}`,
            "target": "_blank"
          }
        }, [_vm._v(_vm._s(item.title))]), _vm._v("\n           \n          "), item.id ? _c('span', {
          staticStyle: {
            "font-size": "10px"
          }
        }, [_vm._v("(" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.id) + ")")]) : _vm._e()];
      }
    }], null, false, 2779955678)
  })] : _vm._e(), !(_vm.twinDependencies && _vm.twinDependencies.aggregatedStates && _vm.twinDependencies.aggregatedStates.length) && !_vm.hasDependentTemplates ? [_vm._v("\n      " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.twinDeleteConfirmText')) + "\n    ")] : _vm._e()], 2), _c('core-csv-export-dialog-multi', {
    attrs: {
      "isOpen": _vm.showExportDialog,
      "type": "digitalTwin"
    },
    on: {
      "close": function ($event) {
        _vm.showExportDialog = false;
      }
    }
  }), _c('core-header', {
    attrs: {
      "headline": _vm.$i18n_t('Common.digitalTwins.head'),
      "subtitle": _vm.$i18n_t('Common.digitalTwins.headInfo')
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "data-cy": "dt_csv_export",
            "color": _vm.color,
            "prepend-icon": "fa-file-csv"
          },
          on: {
            "click": function ($event) {
              _vm.showExportDialog = true;
            }
          }
        }), _c(VBtn, {
          class: 'v-btn-x mx-1 v-btn--rounded bg-rounded-button-' + _vm.color,
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.home.favorites'),
            "icon": "",
            "info": "",
            "fab": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              _vm.favouriteFilter = !_vm.favouriteFilter;
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "dark": ""
          }
        }, [_vm._v(_vm._s(_vm.favouriteFilter ? 'fas' : 'fal') + " fa-star")])], 1), _c('core-account-filter', {
          attrs: {
            "multiple": ""
          },
          on: {
            "change": accounts => {
              _vm.selectedAccounts = accounts;
            },
            "ready": function ($event) {
              _vm.accountFilterReady = true;
            }
          }
        }), _c(VBtn, {
          class: `v-btn-x mx-1 v-btn--rounded bg-rounded-button-${_vm.color}`,
          attrs: {
            "color": _vm.color,
            "rounded": "",
            "text": ""
          },
          on: {
            "click": function ($event) {
              return _vm.$router.push('/digitaltwin-mgmt');
            }
          }
        }, [_c(VIcon, {
          attrs: {
            "dark": ""
          }
        }, [_vm._v("fal fa-sitemap")]), _vm._v("\n          " + _vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.treeView')) + "\n      ")], 1)];
      },
      proxy: true
    }])
  }), _c(VRow, {
    staticClass: "n20-mainrow",
    staticStyle: {
      "min-width": "0"
    }
  }, [_c(VCol, {
    attrs: {
      "cols": "12"
    }
  }, [_c('core-n20Card', [_c('custom-multi-search', {
    attrs: {
      "searchTypes": _vm.searchTypes,
      "searchItems": _vm.searchItems,
      "defaultSearchType": {
        param: 'title',
        text: 'Title'
      },
      "dense": ""
    },
    on: {
      "updated": _vm.searchUpdated
    }
  }), _c('div', {
    staticStyle: {
      "text-align": "right"
    }
  }, [_c('custom-table-column-select', {
    attrs: {
      "items": _vm.customizableColumns,
      "max-height": "300",
      "min-width": "200",
      "data-cy": "column_select"
    },
    on: {
      "update": _vm.handleColumnUpdate
    }
  })], 1), _vm.accountFilterReady ? _c(VDataTable, {
    attrs: {
      "data-cy": "digitaltwin_data_table",
      "data-cy-state": _vm.isFetching ? 'loading' : 'loaded',
      "items": _vm.list,
      "loading": _vm.isFetching,
      "server-items-length": _vm.serverItemsLength,
      "options": _vm.tableOptions,
      "headers": _vm.computedVisibleHeaders,
      "footer-props": _vm.footerProps,
      "item-key": "id"
    },
    on: {
      "update:options": [function ($event) {
        _vm.tableOptions = $event;
      }, _vm.updatePagination]
    },
    scopedSlots: _vm._u([{
      key: "item.icon",
      fn: function ({
        item
      }) {
        return [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "small": ""
          }
        }, [_vm._v("\n              " + _vm._s(item.data.faIcon ? `fal fa-${item.data.faIcon}` : 'fal fa-sensor-on') + "\n            ")])];
      }
    }, {
      key: "item.hierarchyLevel",
      fn: function ({
        item
      }) {
        return [item.parent ? [_vm._v("\n              " + _vm._s(item.hierarchyLevel) + " \n              "), _c('router-link', {
          attrs: {
            "to": `/digitaltwin-mgmt/${item.parent.id}`
          }
        }, [_c(VIcon, {
          attrs: {
            "size": "11"
          }
        }, [_vm._v("fal fa-folder-tree")]), _vm._v("\n                  " + _vm._s(item.parent.title) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.parent.id) + ")\n              ")], 1)] : [_vm._v(_vm._s(_vm.$i18n_t('DigitalTwin.DigitalTwin.list.rootItem')))]];
      }
    }, {
      key: "item.tenant.name",
      fn: function ({
        item
      }) {
        return [_vm._v("\n            " + _vm._s(item.tenant.name) + " (" + _vm._s(_vm.$i18n_t('Common.id')) + ": " + _vm._s(item.tenant.id) + ")\n          ")];
      }
    }, {
      key: "item.statesCount",
      fn: function ({
        item
      }) {
        return [_vm._v(_vm._s(item.statesCount) + " / " + _vm._s(item.rulesCount))];
      }
    }, {
      key: "item.data.address.formatted_address",
      fn: function ({
        item
      }) {
        return [_vm._v("\n            " + _vm._s(_vm.get(item, 'data.address.formatted_address', null)) + "\n          ")];
      }
    }, {
      key: "item.dynamical-data-routing-destination",
      fn: function ({
        item
      }) {
        return [item['dynamical-data-routing-destination'].length > 0 ? _vm._l(item['dynamical-data-routing-destination'], function (destination) {
          return _c(VChip, {
            key: destination.id,
            staticStyle: {
              "margin-right": "4px"
            },
            attrs: {
              "small": ""
            }
          }, [_c('span', {
            staticStyle: {
              "font-weight": "bold"
            }
          }, [_vm._v(_vm._s(Object.keys(destination)[0]))]), _vm._v("\n                : " + _vm._s(destination[Object.keys(destination)[0]]) + "\n              ")]);
        }) : _vm._e()];
      }
    }, {
      key: "item.createdAt",
      fn: function ({
        item
      }) {
        return [_vm._v("\n            " + _vm._s(_vm.localizeDate(item.createdAt)) + "\n          ")];
      }
    }, {
      key: "item.updatedAt",
      fn: function ({
        item
      }) {
        return [_vm._v("\n            " + _vm._s(_vm.localizeDate(item.updatedAt)) + "\n          ")];
      }
    }, {
      key: "item.actions",
      fn: function ({
        item
      }) {
        return [_c('div', {
          staticStyle: {
            "display": "flex",
            "justify-content": "flex-end",
            "align-items": "center",
            "gap": "4px"
          }
        }, [_vm.twinCanBeEdited(item) && item.parentId > 1 ? [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.duplicateDigitalTwin'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              _vm.twinObject = item;
              _vm.twinDuplicatePrompt = true;
            }
          }
        }, [_vm._v("\n                  fal fa-copy\n                ")]), _vm._v("\n                 \n              ")] : _vm._e(), _vm.twinCanBeEdited(item) ? [_vm.twinCanBeEdited(item) ? _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.syncDigitalTwin'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              _vm.twinObject = item;
              _vm.twinSyncPrompt = true;
            }
          }
        }, [_vm._v("\n                  fal fa-share-square\n                ")]) : _vm._e(), _vm._v("\n                 \n              ")] : _vm._e(), _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinLoadMap'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.$router.push(`/digitaltwin-mgmt/map/twin/${item.id}`);
            }
          }
        }, [_vm._v("\n                fal fa-map-marked\n              ")]), _vm._v("\n               \n              "), _vm.hasTwinManageAllPermission && item.parentId && (!item.children || item.children.length === 0) ? [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('DigitalTwin.DigitalTwin.twinDelete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              _vm.twinObject = item;
              _vm.twinDeletePrompt = true;
              _vm.fetchTwinDependencies(_vm.twinObject);
            }
          }
        }, [_vm._v("\n                  fal fa-trash-alt\n                ")]), _vm._v("\n                 \n              ")] : _vm._e(), _c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.viewDetails'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.$router.push(`/digitaltwin-mgmt/${item.id}`);
            }
          }
        }, [_vm._v("\n                fal " + _vm._s(_vm.twinCanBeEdited(item) ? 'fa-edit' : 'fa-eye') + "\n              ")])], 2)];
      }
    }, {
      key: "footer.page-text",
      fn: function (items) {
        return [_c(VRow, {
          staticClass: "text-center align-center"
        }, [_c(VCol, {
          attrs: {
            "cols": "7",
            "md": "7"
          }
        }, [_vm._v("\n                " + _vm._s(items.pageStart) + "-" + _vm._s(items.pageStop) + " " + _vm._s(_vm.$i18n_t('Common.of')) + " " + _vm._s(items.itemsLength) + "\n              ")]), _c(VCol, {
          attrs: {
            "cols": "5",
            "md": "5"
          }
        }, [_c('niota-classic-common-table-page-selector', {
          attrs: {
            "page": _vm.tableOptions.page,
            "table-max-items": _vm.serverItemsLength,
            "table-items-per-page": _vm.tableOptions.itemsPerPage,
            "title-txt": _vm.$i18n_t('Common.goToPage')
          },
          on: {
            "page-change": function ($event) {
              return _vm.setCurrentTablePage($event);
            }
          }
        })], 1)], 1)];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n              " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n            ")])];
      },
      proxy: true
    }], null, false, 577770029)
  }) : _vm._e()], 1)], 1)], 1)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };